// extracted by mini-css-extract-plugin
module.exports = {"container":"user-card_container__2bu4V"};